<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <ng-container *ngFor="let crumb of crumbPaths">
            <li class="breadcrumb-item" [ngClass]="{'active' : crumb.active}" *ngIf="crumb.hidden != true">
                <a style="color: blue; cursor: pointer;" (click)="navigate(crumb)" *ngIf="!crumb.active; else crumbdirect">{{crumb.name}}</a>
                <ng-template #crumbdirect>{{crumb.name}} </ng-template>
            </li>
        </ng-container>
    </ol>
</nav>